import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Button, Modal} from 'react-bootstrap';
import { PageTitle } from '../PageTitle';
import update from 'immutability-helper';
import moment from 'moment-timezone';
import { Message } from '../Message';
import Select, { components } from 'react-select';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faWarning from '@fortawesome/fontawesome-free-solid/faExclamationTriangle';

import DeviceEditTagsForm from './device_tags_edit_form';
import DeviceExclusionEditForm from './device_exclusion_edit_form';
import EntityImageGallery from '../Entity/entity_image_gallery';
import { DevicesService, DeviceStatusesService, GroupingsService, TagsService, HologramService, TimeFormattingService } from '../../services';
import { HologramHelper } from '../../helpers';
import { PageLevelAccess } from '../PageLevelAccess';
import DeviceSIMActivationForm from './device_sim_activation_form';
import i18next from "i18next";
import {SwitchInput} from '../SwitchInput';
import { FeatureAccess } from '../FeatureAccess';

import config from "config";

class DeviceEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      deviceId: props.match.params.deviceId,
      device: null,
      totalEventsForDevice: -1,
      errorMessage: null,
      successMessage: this.props.location.state ? this.props.location.state.successMessage : null
    };
  }

  componentDidMount() {
    DevicesService.get(this.state.deviceId).then((response) => {
      this.setState({ device: response.device });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-device') });
      console.error(error);
    });

    // Get ALL alerts for device
    DevicesService.getTotalEventCount(this.state.deviceId).then((response) => {
      this.setState({totalEventsForDevice: response.eventCount})
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-device') });
      console.error(error);
    });
  }

  render() {
    if (this.state.errorMessage) {
      return (
        <Redirect to={{
          pathname: '/config/devices',
          state: {
            errorMessage: this.state.errorMessage
          }
        }}
        />
      );
    }

    if (this.state.device && this.state.totalEventsForDevice >= 0) {
      return (
        <ModifiableDeviceDetail
          device={this.state.device}
          totalEventsForDevice={this.state.totalEventsForDevice}
          location={this.props.location}
          successMessage={this.state.successMessage}
        />
      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }
}

@connect(state => {
  return {
    currentGrouping: state.currentGrouping.currentGrouping,
    me: state.user.me
  };
})
class ModifiableDeviceDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddGroupingModal: false,
      showChangeStatusModal: false,
      showEditValueModal: false,
      availableDeviceStatuses: null,
      device: this.props.device,
      tags:this.props.device.tags,
      totalEventsForDevice: this.props.totalEventsForDevice,
      localErrorMessage: null,
      localSuccessMessage: this.props.successMessage ? this.props.successMessage : null,
      showAddImageModal: false,
      showReplaceImageModal: false,
      showDeleteEventsModal: false,
      showSIMActivationModal: false,
      hideInternalMetadata: this.props.location.state && typeof this.props.location.state.hideInternalMetadata === 'boolean' ? this.props.location.state.hideInternalMetadata : true,
      deviceMetadata: this.props.device.deviceMetadata,
      backLinkSearch: this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null,
      backLinkWithParams: this.props.location.state && this.props.location.state.backLinkWithParams ? this.props.location.state.backLinkWithParams : null,
      searchValue: this.props.location.state && this.props.location.state.searchValue ? this.props.location.state.searchValue : null,
      thresholdDeviceDataTypeExclusions: this.props.device.thresholdDeviceDataTypeExclusions.map((exclusion) => exclusion.deviceDataType)
    };

    this.toggleAddGroupingModal = this.toggleAddGroupingModal.bind(this);
    this.toggleChangeStatusModal = this.toggleChangeStatusModal.bind(this);
    this.handleMetadataEditChange = this.handleMetadataEditChange.bind(this);
    this.handleDeviceMetadataEditChange = this.handleDeviceMetadataEditChange.bind(this);
    this.toggleShowAddImageModal = this.toggleShowAddImageModal.bind(this);
    this.toggleShowReplaceImageModal = this.toggleShowReplaceImageModal.bind(this);
  }

  toggleShowAddImageModal() {
    this.setState({
      showAddImageModal: !this.state.showAddImageModal
    });
  }

  toggleShowReplaceImageModal() {
    this.setState({
      showReplaceImageModal: !this.state.showReplaceImageModal
    });
  }

  toggleDeleteEventsModal() {
    this.setState({
      showDeleteEventsModal: !this.state.showDeleteEventsModal
    });
  }

  toggleInternalMetadata() {
    if (this.props.me.userType.token === 'internal') {
      this.setState({hideInternalMetadata: !this.state.hideInternalMetadata});
    }
  }

  toggleSIMActivationModal() {
    this.setState({
      showSIMActivationModal: !this.state.showSIMActivationModal
    });
  }

  replaceImage(index) {
      this.state.replaceIndex = index
      this.toggleShowReplaceImageModal()
  }

  openImage() {
    this.toggleShowDeviceImageModal()
  }

  deleteImage(i) {
    const device = this.state.device;
    DevicesService.deleteImage(device.id, this.state.device.deviceImages[i].name, this.state.device.deviceImages[i].id).then(response => {
      device.deviceImages.splice(i, 1)
        this.setState({ localSuccessMessage: i18next.t('messages.device-image-deleted-success'), localErrorMessage: null, device: device });
    }).catch(error => {
      this.setState({ device: device, localErrorMessage: i18next.t('messages.device-image-deleted-failure'), localSuccessMessage: null });
      console.error(error);
    })
  }

  onDeviceUploadDrop(file, i) {
    // TODO need loading dialog here while uploading
    const device = this.state.device;
    this.setState({ device: null });
    let ROOT = DevicesService.getRoot();
    if (device.deviceImages[i]) {
      DevicesService.replaceImage(device.id, file[0], device.deviceImages[i].id).then(response => {
        if (response.deviceImage) {
          device.deviceImages[i] = response.deviceImage
          this.setState({ localSuccessMessage: i18next.t('messages.device-image-replaced-success'), localErrorMessage: null});
        }
        this.setState({ device: device });
        this.toggleShowReplaceImageModal();
      }).catch(error => {
        this.setState({ device: device, localErrorMessage: i18next.t('messages.device-image-replaced-failure'), localSuccessMessage: null });
        console.error(error);
      })
    } else {
      DevicesService.uploadImage(device.id, file[0]).then(response => {
        if (response.deviceImage) {
          device.deviceImages[i] = response.deviceImage
          this.setState({ localSuccessMessage: i18next.t('messages.device-image-upload-success'), localErrorMessage: null});
        }
        this.setState({ device: device });
        this.toggleShowAddImageModal();
      }).catch(error => {
        this.setState({ device: device, localErrorMessage: i18next.t('messages.device-image-upload-failure'), localSuccessMessage: null });
        console.error(error);
      })
    }
  }
  
  isSIMActivationAllowed() {
    let cellEnabledMetadata = this.state.device.deviceMetadata.find(dmd => dmd.deviceMetadataType.name === 'cell_enabled');
    let cellIMEIMetadata = this.state.device.deviceMetadata.find(dmd => dmd.deviceMetadataType.name === 'cell_imei');
    return cellEnabledMetadata && cellEnabledMetadata.numericValue != null && cellEnabledMetadata.numericValue === 1  && !cellIMEIMetadata;
  }

  componentDidMount() {
    const availableMetadataValueTypes = this.state.device.deviceType.metadataTypes.filter(metadataType => metadataType.groupAssociableMetadataTypes.length === 0);
    const currentMetadata = availableMetadataValueTypes
        .filter(metadataType => metadataType.syncDirection.id !== 2)
        .sort((entryA, entryB) => entryA.displayOrder - entryB.displayOrder);

    // Set device name to serial number if none exists
    const nameMetadataType = currentMetadata.find(metadata => metadata.name === 'name');
    const existingName = this.state.device.deviceMetadata.find(metadata => metadata.deviceMetadataType.name === 'name');

    if (nameMetadataType && !existingName) {
      this.handleDeviceMetadataEditChange(null, nameMetadataType, this.state.device.serialNumber);
    }

    this.setState({metadataToEdit: currentMetadata, simActivationAllowed: this.isSIMActivationAllowed()});

    DeviceStatusesService.getAll().then(response => {
      let currentStatus = this.props.device.deviceStatus;
      this.setState({
        availableDeviceStatuses: response.deviceStatuses.map(status => ({value: status.id, label: status.name, token: status.token})),
        selectedStatus: {value: currentStatus.id, label: currentStatus.name, token: currentStatus.token}
      });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-device-statuses') });
      console.error(error);
    });
    GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
      this.setState({
        groupingFilterOptions: response.groupings,
        selectedGrouping: this.state.device.deviceGrouping ? {label: this.state.device.deviceGrouping.name, value: this.state.device.deviceGrouping.id} : null
      });
    }).catch(error => {
      console.error(error);
      this.state.localErrorHandler(error.message);
    });
  }

  messageDismissCallback() {
    this.setState({
      localErrorMessage: null,
      localSuccessMessage: null
    });
  }

  groupingUpdated(grouping) {
    let assignedTags = this.state.tags.map(tag => {return tag.id});

    if (grouping) {
      TagsService.findChecklistDeviceTagsAssignedForGrouping(grouping.value, assignedTags).then((response) => {
        if (response.tags.length) {
          let tagsAssignedForNewGrouping = response.tags.map(tag => {return tag.name}).join(', ');
          this.setState({localErrorMessage:  i18next.t('messages.duplicate-checklist-tag', {count:response.tags.length, tags:tagsAssignedForNewGrouping, label:grouping.label}) })
        } else {
          this.setState({ selectedGrouping: grouping });
        }
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-tags-view') });
      });
    } else {
      this.setState({selectedGrouping: grouping});
    }
  }

  statusUpdated(status) {
    this.setState({ selectedStatus: status });
  }

  tagsUpdated(data) {
    let tagsData =[];
    Object.keys(data).map(function(key) {
      if(key!== 'preventDefault')
        tagsData.push({id : data[key].value})
    });
    this.setState({ tags: tagsData });
  }

  setIntialTags() {
    let tagsData = [];
    const existingTags = this.state.device.tags;
    Object.keys(existingTags).map(function(key) {
      tagsData.push({label : existingTags[key].name, value:existingTags[key].id })
    });
    return tagsData;
  }

  updateDevice() {
    const existingDevice = this.state.device;
    
    // Replace cleared device name with serial number
    const nameMetadata = this.state.deviceMetadata.find(metadata => metadata.deviceMetadataType.name === 'name');
    
    if (nameMetadata != null && !nameMetadata.stringValue) {
      this.handleDeviceMetadataEditChange(nameMetadata, nameMetadata.deviceMetadataType, this.state.device.serialNumber);
    }
    const currentMetadataIds = _.map(this.state.metadataToEdit, 'id');
    const editedMetadata = this.state.deviceMetadata.filter(deviceMetadata => currentMetadataIds.includes(deviceMetadata.deviceMetadataType.id));

    let validationErrors = false;

    editedMetadata.filter(metadata => metadata.numericValue != null).forEach(metadata => {
      let metadataNumericValue = parseFloat(metadata.numericValue);

      if (metadata.deviceMetadataType.minNumericValue != null && metadataNumericValue < metadata.deviceMetadataType.minNumericValue) {
        validationErrors = true;
        this.setState({
          localSuccessMessage: null,
          localErrorMessage: i18next.t('messages.metadata-too-low', {type: i18next.t(`device-metadata-types.${metadata.deviceMetadataType.name}`), minimum:metadata.deviceMetadataType.minNumericValue})
        })
      } else if (metadata.deviceMetadataType.maxNumericValue != null && metadataNumericValue > metadata.deviceMetadataType.maxNumericValue) {
        validationErrors = true;
        this.setState({
          localSuccessMessage: null,
          localErrorMessage: i18next.t('messages.metadata-too-high', {type: i18next.t(`device-metadata-types.${metadata.deviceMetadataType.name}`), maximum:metadata.deviceMetadataType.maxNumericValue})
        })
      }
    });

    editedMetadata.forEach(metadata => {
      metadata.lastDeviceMetadataUpdate = null;
    });

    if (validationErrors) {
      return;
    }

    const thresholdDeviceDataTypeExclusions = this.state.thresholdDeviceDataTypeExclusions.map((edt) => {
      const foundExisting = this.state.device.thresholdDeviceDataTypeExclusions.find((exclusion) => exclusion.deviceDataType.id === edt.id);
      if (foundExisting) {
        return foundExisting;
      } else {
        return ({ deviceDataType: edt, includeDataTypes: false });
      }
    });

    this.setState({ device: null }, () => {
      const groupingHash = this.state.selectedGrouping ? { id: this.state.selectedGrouping.value } : { id: null }
      let updatedData = {
        status: {id: this.state.selectedStatus.value},
        grouping: groupingHash,
        metadata: editedMetadata,
        tags: this.state.tags,
        thresholdDeviceDataTypeExclusions: thresholdDeviceDataTypeExclusions
      };
      DevicesService.updateConfiguration(this.props.device.id, updatedData).then(response => {
        this.setState({
          device: response.device,
          deviceMetadata: response.metadata,
          localSuccessMessage: i18next.t('messages.device-save-success'),
          redirectToDeviceView: response.device.id,
          localErrorMessage: null
        });
      }).catch((error) => {
        console.dir(error);
        const errorMessage = error && error.response && error.response.data && error.response.data.genericSystemErrorMessage ? error.response.data.genericSystemErrorMessage : i18next.t('messages.device-save-failure');
        this.setState({
          device: existingDevice,
          localErrorMessage: errorMessage,
          localSuccessMessage: null
        });
        console.error(error);
      });
    });
  }

  deleteAllEventsForDevice() {
      DevicesService.deleteAllEventsForDevice(this.state.device.id).then(() => {
        this.setState({totalEventsForDevice: 0});
        this.toggleDeleteEventsModal();
      }).catch(err => {
        console.err(err);
        this.setState({localErrorMessage: i18next.t('messages.delete-event-failure')});
      });
  }

  renderStatusOptions(option) {
    return (
        <span><img height='16' src={`${config.WEB_BASE_URL}/images/icon/sensor_${option.token}.svg`} /> &nbsp;{ i18next.t(`device-statuses.${option.token}`) }&nbsp;</span>
    )
  }

  collectGroupIdsFromGroupTree(parentGrouping, groupIds) {
    if (parentGrouping != null) {
      this.collectGroupIdsFromGroupTree(parentGrouping.parent, groupIds);
      groupIds.push(parentGrouping.deviceGroupId);
    }
    return groupIds;
  }

  constructAMTBasedEntries() {
    if (this.state.device.deviceGrouping == null) {
      return null;
    }
    const parentGroupIds = new Set(this.collectGroupIdsFromGroupTree(this.state.device.deviceGrouping.parent, [this.state.device.deviceGrouping.deviceGroup.id]));
    const availableMetadataValueTypesWithAMT = this.state.device.deviceType.metadataTypes.filter(metadataType =>
        metadataType.groupAssociableMetadataTypes.length > 0 &&
        metadataType.groupAssociableMetadataTypes.some(amt => amt.validForGroups.some(validForId => parentGroupIds.has(validForId)))
    );

    const uniqueGroupAssociableMetadataTypes = availableMetadataValueTypesWithAMT.reduce((result, metadataType) => {
      return result.concat(metadataType.groupAssociableMetadataTypes);
    }, []).reduce((result, amt) => {
      if (result.filter(t => t.id === amt.id).length === 0) {
        return result.concat(amt);
      }
      return result;
    }, []);

    const deviceLocationEdit = uniqueGroupAssociableMetadataTypes.map(groupAssociableMetadataType => (
      <DeviceLocationEditButton
        key={groupAssociableMetadataType.id}
        device={this.state.device}
        groupAssociableMetadataType={groupAssociableMetadataType}
        backLinkSearch={this.state.backLinkSearch}
        searchValue={this.state.searchValue}
        backLinkWithParams={this.state.backLinkWithParams}
      />
    ));

    if (uniqueGroupAssociableMetadataTypes.length > 0) {
      return (
        <div>
          {deviceLocationEdit}
        </div>
      );
    } else {
      return null;
    }
  }

  async handleSIMActivation(formData) {
    const deviceEnterprise = this.state.device.enterprise;
    let hologramTagId = HologramHelper.getHologramTag(deviceEnterprise);

    if (!hologramTagId) {
      try {
        hologramTagId = await HologramService.addHologramTag(deviceEnterprise.id);
      } catch (err) {
        console.error(err);
        this.setState({
          localErrorMessage: i18next.t('messages.sim-activation-enterprise-failure', {enterprise: deviceEnterprise.name})
        }, () => this.toggleSIMActivationModal());
      }
    }

    if (hologramTagId) {
      let activationRequest = {
        plan: formData.ratePlan.value,
        zone: formData.zone,
        tagid: hologramTagId
      }
  
      HologramService.activateSIM(this.state.device.id, formData.iccid, activationRequest).then(response => {
        this.setState({simActivationAllowed: false, localSuccessMessage: `SIM ${formData.iccid} has been activated.`}, () => this.toggleSIMActivationModal());
      }).catch(err => {
        console.error(err);
        this.setState({localErrorMessage: i18next.t('messages.sim-activation-failure')}, () => this.toggleSIMActivationModal());
      });
    }
  }

  render() {
    if (this.state.redirectToDeviceView) {
      return (
        <Redirect to={{
          pathname: `/config/devices/view/${this.state.redirectToDeviceView}`,
          state: {
            successMessage: this.state.localSuccessMessage
          }
        }}
        />
      );
    }

    if (!this.state.device || !this.state.availableDeviceStatuses || !this.state.groupingFilterOptions) {
      return (<div className="loader">{ i18next.t('loading') }</div>);
    }
    if (this.state.availableDeviceStatuses) {
      const generateLinkToEditDevicePlacement = this.constructAMTBasedEntries();

      const SingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
          {this.renderStatusOptions(props.selectProps.value)}
        </components.SingleValue>
      );

      const Option = (props) => (
        <components.Option {...props}>
          {this.renderStatusOptions(props.data)}
        </components.Option>
      );

      const customStyles = {
        container: () => ({
          // none of react-selects styles are passed to <View />
          height: 36,
        })
      }

      const backLinkWithParams = this.state.backLinkWithParams ? this.state.backLinkWithParams
      : {
          link: {
            pathname: '/config/devices',
            search: this.state.backLinkSearch,
            state: {
              searchValue: this.state.searchValue
            }
          }
      };

      let filteredMetadataToEdit = this.state.metadataToEdit && this.state.hideInternalMetadata ? this.state.metadataToEdit.filter(metadataType => !metadataType.internal) : this.state.metadataToEdit;

      return (
        <div className="device-edit devices">
          <div className="row">
            <PageTitle 
              title={this.state.device.displayName}
              backLinkWithParams={backLinkWithParams}
            />
          </div>

          <div className="op-content-box">
            <div>
              <Message
                messages={{ state: { successMessage: this.state.localSuccessMessage } }}
                errorMessage={this.state.localErrorMessage}
                messageDismissCallback={this.messageDismissCallback.bind(this)}
              />

              <div className="row">
                <div className="col-sm-3">
                  <div className="row">
                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-category">
                        <label>{ i18next.t('form-labels.device-serial-number') }</label>
                        <p style={{wordWrap: 'break-word'}}>{this.state.device.serialNumber}</p>
                      </div>
                    </div>
                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-category">
                        <label>{ i18next.t('form-labels.device-type') }</label>
                        <p style={{wordWrap: 'break-word'}}>{ i18next.t(`device-types.${this.state.device.deviceType.token}`) }</p>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="row">
                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-status">
                        <label>{ i18next.t('form-labels.status') }</label>
                        <Select
                          name="deviceStatus"
                          options={this.state.availableDeviceStatuses}
                          value={this.state.selectedStatus}
                          isClearable={false}
                          onChange={this.statusUpdated.bind(this)}
                          components={{ SingleValue, Option }}
                          styles={customStyles}
                          className="react-select-container device-edit-select"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-group">
                        <label>{ i18next.t('form-labels.group') }</label>
                        <Select
                            ref="filterByGroupingSelect"
                            options={this.state.groupingFilterOptions}
                            isClearable={true}
                            name="selected-filter-by"
                            value={this.state.selectedGrouping}
                            onChange={this.groupingUpdated.bind(this)}
                            isSearchable={true}
                            className="business-filter"
                            className="react-select-container"
                            classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="card-data-side-info">
                    <div className="row">
                      <div className="col-sm-8 col-md-6 form-group">
                        <div className="card-data-cell remove-border-left">
                          <label>{ i18next.t('form-labels.first-detected-at') }</label>
                          <p>{TimeFormattingService.renderNormalTime(this.state.device.firstDetectedAt, this.state.device.deviceGrouping ? this.state.device.deviceGrouping.timezone : null)}</p>
                        </div>
                      </div>
                      <div className="col-sm-8 col-md-6 form-group">
                        <div className="card-data-cell remove-border-left">
                          <label>{ i18next.t('form-labels.last-device-time') }</label>
                          <p>{TimeFormattingService.renderNormalTime(this.state.device.lastDeviceTime, this.state.device.deviceGrouping ? this.state.device.deviceGrouping.timezone : null)}</p>
                        </div>
                      </div>
                      <div className="col-sm-8 col-md-6">
                        <div className="card-data-cell remove-border-left">
                          <label>{ i18next.t('form-labels.last-updated') }</label>
                          <p>{TimeFormattingService.renderFromNowTime(this.state.device.lastUpdatedAt, this.state.device.deviceGrouping ? this.state.device.deviceGrouping.timezone : null)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              { this.state.simActivationAllowed && 
              <PageLevelAccess to="/config/devices/edit/:deviceId#cell-service">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="pull-right">
                      <button className="btn btn-sm btn-default" onClick={() => this.toggleSIMActivationModal()}>{ i18next.t('form-labels.activate-sim') }</button>
                    </div>
                  </div>
                </div>
              </PageLevelAccess>
              }
              <div className="row grey-box">
                <div className="row grey-box">
                  {
                    filteredMetadataToEdit && filteredMetadataToEdit.length > 0 ?
                      <div className="col-sm-8 oc-mini-card oc-mini-card">
                        <div className="panel-heading">
                          { i18next.t('pages.device-configuration.metadata') }
                          { this.props.me.userType.token === 'internal' &&
                            <span className="inline pull-right">
                            <label>
                            <input 
                              type="checkbox"
                              className="inline"
                              checked={this.state.hideInternalMetadata}
                              onChange={this.toggleInternalMetadata.bind(this)}
                            />
                              { i18next.t('form-labels.hide-internal') }
                            </label>
                          </span>
                          }
                        </div>
                        <div className="inner metadata-inner form-control">
                          <table className="table table-striped">
                            <thead>
                            <tr>
                              <th>{ i18next.t('table-headers.name') }</th>
                              <th>{ i18next.t('table-headers.current-value') }</th>
                              <th>{ i18next.t('table-headers.direction') }</th>
                              <th>{ i18next.t('table-headers.last-sync-status') }</th>
                            </tr>
                            </thead>
                            <tbody>
                              {filteredMetadataToEdit.map(metadataType => (
                                <MetadataRow
                                  key={metadataType.id}
                                  metadataType={metadataType}
                                  currentDeviceMetadata={this.state.deviceMetadata}
                                  timezone={this.state.device.deviceGrouping ? this.state.device.deviceGrouping.timezone : null}
                                  handleDeviceMetadataEditChange={this.handleDeviceMetadataEditChange}
                                />
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      : null
                  }

                  <div className="col-sm-4 oc-mini-card oc-mini-card">
                    <div className="panel-heading">
                      { i18next.t('pages.device-configuration.device-image') }
                    </div>
                    <div className="inner metadata-inner">
                      <EntityImageGallery 
                          serialNumber={this.state.device?.serialNumber}
                          images={this.state.device?.deviceImages ?? []} 
                          onDelete={this.deleteImage.bind(this)} 
                          onReplace={this.replaceImage.bind(this)}
                        />
                      <div> </div>
                      <Button className="btn btn-sm btn-default" style={{ width: '100%' }} onClick={this.toggleShowAddImageModal}>{ i18next.t('form-labels.add-device-image') }</Button>
                    </div>
                  </div>
                </div>

                <FeatureAccess feature="ENABLE_THRESHOLD_CLASSIFICATION_MATCHING">
                  <div className="row grey-box">
                    <div className="col-sm-12 oc-mini-card oc-mini-card">
                      <div className="panel-heading">Measure Type Threshold Exclusions</div>
                      <div className="inner metadata-inner form-control">
                        <DeviceExclusionEditForm 
                          thresholdDeviceDataTypeExclusions={this.state.thresholdDeviceDataTypeExclusions} 
                          deviceDataTypes={this.state.device.deviceType.dataTypes}
                          onSelection={(thresholdDeviceDataTypeExclusions) => { this.setState({ thresholdDeviceDataTypeExclusions: thresholdDeviceDataTypeExclusions }); }}
                        />
                      </div>
                    </div>
                  </div>
                </FeatureAccess>
              </div>

              <div className="row grey-box">
                <div className="col-sm-6 oc-mini-card oc-mini-card">
                  <div className="panel-heading">
                    { i18next.t('pages.device-configuration.floor-plan-location') }
                  </div>
                  <div className="inner metadata-inner form-control floor-plan">
                    <img className="floor-plan-thumbnail" src={`${config.WEB_BASE_URL}/images/floor_plan.svg`} />
                    {generateLinkToEditDevicePlacement}
                  </div>
                </div>
                <div className="col-sm-4 oc-mini-card oc-mini-card">
                  <div className="panel-heading">
                    { i18next.t('pages.device-configuration.tags') }
                  </div>
                  <div className="inner metadata-inner form-control">
                    <DeviceEditTagsForm
                      onSelection={this.tagsUpdated.bind(this)}
                      initialValues={{ tags: this.setIntialTags() }}
                      deviceGrouping={this.state.selectedGrouping}
                      deviceId={this.state.device.id}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <hr />
                  <ul className="list-inline">
                    <li>
                      <button className="btn btn-primary" onClick={this.updateDevice.bind(this)}>{ i18next.t('form-labels.save') }</button>
                    </li>
                    <li>
                      <Link to={ backLinkWithParams ? backLinkWithParams.link : `/config/devices`}>
                        <button className="btn btn-default">{ i18next.t('form-labels.cancel') }</button>
                      </Link>
                    </li>
                    <li className="pull-right">
                    {this.state.totalEventsForDevice > 0 ?
                    <PageLevelAccess to='/config/devices/:deviceId/events#delete'>
                      <button className="btn btn-danger" onClick={this.toggleDeleteEventsModal.bind(this)}>{ i18next.t('form-labels.delete-event-history') }</button>
                    </PageLevelAccess>
                      : null
                    }
                    </li>
                  </ul>
                </div>
              </div>
              <Modal show={this.state.showDeleteEventsModal} onHide={this.toggleDeleteEventsModal.bind(this)}>
                <Modal.Header style={{backgroundColor: '#d52439'}} closeButton>
                  <Modal.Title style={{color: 'white'}}><FontAwesomeIcon icon={faWarning} size={'lg'}/> { i18next.t('form-labels.delete-event-history') }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>{ i18next.t('messages.delete-events-warning', {eventCount:this.state.totalEventsForDevice}) }</p>
                  <p>{ i18next.t('messages.are-you-sure-continue' )}</p>
                </Modal.Body>
                <Modal.Footer>
                  <button className="btn btn-danger" onClick={this.deleteAllEventsForDevice.bind(this)}>{ i18next.t('form-labels.yes') }</button>
                  <button className="btn btn-default" onClick={this.toggleDeleteEventsModal.bind(this)}>{ i18next.t('form-labels.cancel') }</button>
                </Modal.Footer>
              </Modal>

              <Modal show={this.state.showAddImageModal} onHide={this.toggleShowAddImageModal}>
                <Modal.Header closeButton>
                  <Modal.Title>{ i18next.t('pages.device-configuration.device-image') }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="device-dropzone">
                    <Dropzone className="dropzone-format" onDrop={(files) => this.onDeviceUploadDrop(files, this.state.device.deviceImages.length)}>
                      <div style={{textAlign: "center", top: "45%", position: "relative"}}> { i18next.t('pages.device-configuration.drag') } </div>
                      <button style={{margin: "0 auto", display: "block", position: "relative", top: "110px"}} className="btn btn-sm btn-default"> { i18next.t('pages.device-configuration.upload') } </button>
                    </Dropzone>
                  </div>
                </Modal.Body>
              </Modal>

              <Modal show={this.state.showReplaceImageModal} onHide={this.toggleShowReplaceImageModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Replace Device Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="device-dropzone">
                    <Dropzone className="dropzone-format" onDrop={(files) => this.onDeviceUploadDrop(files, this.state.replaceIndex)}>
                      <div style={{ textAlign: 'center', top: '45%', position: 'relative' }}> { i18next.t('pages.device-configuration.drag') } </div>
                      <button style={{ margin: '0 auto', display: 'block', position: 'relative', top: '110px' }} className="btn btn-sm btn-default"> { i18next.t('pages.device-configuration.upload') } </button>
                    </Dropzone>
                  </div>
                </Modal.Body>
              </Modal>

              <Modal show={this.state.showSIMActivationModal} onHide={this.toggleSIMActivationModal.bind(this)}>
                <Modal.Header closeButton>
                  <Modal.Title>{ i18next.t('pages.device-configuration.activate-sim') }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <DeviceSIMActivationForm onSubmit={this.handleSIMActivation.bind(this)} onCancel={this.toggleSIMActivationModal.bind(this)}/>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }
  }

  toggleAddGroupingModal() {
    this.setState({
      showAddGroupingModal: !this.state.showAddGroupingModal
    });
  }

  toggleChangeStatusModal() {
    this.setState({
      showChangeStatusModal: !this.state.showChangeStatusModal
    });
  }

  handleMetadataEditChange(event) {
    this.setState({ metadataValueUpdate: event.target.value });
  }

  handleDeviceMetadataEditChange(currentMetadata, deviceMetadataType, updatedValue) {
    let data = this.state.deviceMetadata;

    if (currentMetadata != null) {
      let metadataIndex = data.findIndex(existingMetadata => existingMetadata.deviceMetadataType.id === currentMetadata.deviceMetadataType.id);

      let updatedMetadata = null;
      if(deviceMetadataType.deviceMetadataValueType.name === 'string') {
        updatedMetadata = update(data[metadataIndex], { stringValue: { $set: updatedValue } });
      } else if (deviceMetadataType.deviceMetadataValueType.name === 'numeric') {
        updatedMetadata = update(data[metadataIndex], { numericValue: { $set: parseFloat(updatedValue) } });
      } else if (deviceMetadataType.deviceMetadataValueType.name === 'boolean') {
        updatedMetadata = update(data[metadataIndex], { booleanValue: { $set: updatedValue }});
      }

      this.setState({ deviceMetadata: update(data, { $splice: [[metadataIndex, 1, updatedMetadata]] }) });
    } else {
      let dataToAdd = { deviceMetadataType };

      if (deviceMetadataType.deviceMetadataValueType.name === 'string') {
        dataToAdd.stringValue = updatedValue;
      } else if (deviceMetadataType.deviceMetadataValueType.name === 'numeric') {
        dataToAdd.numericValue = parseFloat(updatedValue);
      } else if (deviceMetadataType.deviceMetadataValueType.name === 'boolean') {
        dataToAdd.booleanValue = updatedValue;
      }

      this.setState({ deviceMetadata: update(data, { $push: [dataToAdd] }) });
    }
  }
}

class MetadataRow extends React.Component {
  getRestrictedSelection(currentMetadataValue) {
    if (currentMetadataValue.stringValue) {
      let selectedString = this.props.metadataType.deviceMetadataRestrictedSelections.find(selection => selection.stringValue === currentMetadataValue.stringValue);
      return selectedString != null ? {value: selectedString.stringValue, label: selectedString.displayValue} : '';
    } else {
      let selectedNumeric = this.props.metadataType.deviceMetadataRestrictedSelections.find(selection => selection.numericValue === currentMetadataValue.numericValue);
      return selectedNumeric != null ? {value: selectedNumeric.numericValue, label: selectedNumeric.displayValue} : '';
    }   
  }

  getDisplayValue(metadata) {
    switch (this.props.metadataType.deviceMetadataValueType.name) {
      case 'string': 
        return metadata != null && metadata.stringValue != null ? metadata.stringValue : this.props.metadataType.defaultStringValue;
      case 'numeric':
        return metadata != null && metadata.numericValue != null ? metadata.numericValue : this.props.metadataType.defaultNumericValue;
      case 'boolean':
        const defaultValue = this.props.metadataType.defaultBooleanValue != null ? this.props.metadataType.defaultBooleanValue ? 'On' : 'Off' : null;
        return metadata != null && metadata.booleanValue != null ? metadata.booleanValue ? 'On' : 'Off' : defaultValue ? defaultValue : null;
      default: 
        return i18next.t('unknown');
    }
  }

  getInput(currentMetadataValue, displayValue) {
    if (this.props.metadataType.deviceMetadataValueType.name === 'boolean') {
      const isOn = displayValue === 'On';
      return (
        <SwitchInput
          label={displayValue}
          input={{
            name: "metadataValueUpdate",
            className: "inline",
            checked: isOn,
            onChange: () => this.props.handleDeviceMetadataEditChange(currentMetadataValue, this.props.metadataType, !isOn)
          }}
          meta={{}}
        />);
    } else {
      return (
        <input
          type="text"
          name="metadataValueUpdate"
          value={displayValue != null ? displayValue : ''}
          className="input-sm form-control"
          onChange={event => this.props.handleDeviceMetadataEditChange(currentMetadataValue, this.props.metadataType, event.target.value)}
        />
      )
    }
  }

  render() {
    const isRestrictedMetadataType = this.props.metadataType.deviceMetadataRestrictedSelections.length > 0;
    const currentMetadataValue = this.props.currentDeviceMetadata.find(metadata => metadata.deviceMetadataType.id === this.props.metadataType.id);

    let displayValue = currentMetadataValue != null && isRestrictedMetadataType ? this.getRestrictedSelection(currentMetadataValue) : this.getDisplayValue(currentMetadataValue);

    let currentSyncValue = i18next.t('unknown');
    if (currentMetadataValue != null && currentMetadataValue.deviceMetadataType.syncDirection.none) {
      currentSyncValue = i18next.t('na');
    } else if (currentMetadataValue != null && currentMetadataValue.deviceMetadataType.syncDirection.up && currentMetadataValue.lastSyncTime != null) {
      const timeValue = (this.props.timezone != null ? moment(currentMetadataValue.lastSyncTime).tz(this.props.timezone) : moment(currentMetadataValue.lastSyncTime));
      currentSyncValue = TimeFormattingService.renderNormalTime(timeValue, this.props.timezone ? this.props.timezone : null);
    } else if (currentMetadataValue != null && currentMetadataValue.deviceMetadataType.syncDirection.down && currentMetadataValue.lastDeviceMetadataUpdate != null) {
      let restrictedSelection = isRestrictedMetadataType ? this.getRestrictedSelection(currentMetadataValue.lastDeviceMetadataUpdate) : null;
      const updateValue = restrictedSelection ? restrictedSelection.label : this.getDisplayValue(currentMetadataValue.lastDeviceMetadataUpdate);
      let updateTime = null;
      if (currentMetadataValue.lastDeviceMetadataUpdate.deviceMetadataUpdateStatus.token === 'pending') {
        updateTime = TimeFormattingService.renderNormalTime(this.props.timezone != null ? currentMetadataValue.lastDeviceMetadataUpdate.startedAt : currentMetadataValue.lastDeviceMetadataUpdate.endedAt, this.props.timezone ? this.props.timezone : null);
      } else {
        updateTime = TimeFormattingService.renderNormalTime(currentMetadataValue.lastDeviceMetadataUpdate.endedAt, this.props.timezone ? this.props.timezone : null);
      }
      let changedBy = "";
      if (currentMetadataValue.lastDeviceMetadataUpdate.changedBy != null) {
        changedBy = <span><br/> {i18next.t('changed-by')} {currentMetadataValue.lastDeviceMetadataUpdate.changedBy.firstName} {currentMetadataValue.lastDeviceMetadataUpdate.changedBy.lastName}</span>;
      }
      currentSyncValue = <span>{currentMetadataValue.lastDeviceMetadataUpdate.deviceMetadataUpdateStatus.name} ({updateValue}) { i18next.t('as-of') } {updateTime === null ? i18next.t('na') : updateTime} {changedBy}</span>;
    }

    return (
        <tr key={this.props.metadataType.id}>
          <td>{ i18next.t(`device-metadata-types.${this.props.metadataType.name}`) }</td>
          <td>
            {isRestrictedMetadataType ?
            <Select
              name="metadataValueUpdate"
              options={this.props.metadataType.deviceMetadataRestrictedSelections.sort((a, b) => {return a.displayOrder - b.displayOrder}).map(selection => {return {label: selection.displayValue, value: selection.stringValue != null ? selection.stringValue : selection.numericValue}})}
              value={displayValue ? displayValue : ''}
              isClearable={false}
              onChange={option => this.props.handleDeviceMetadataEditChange(currentMetadataValue, this.props.metadataType, option.value)}             
              className="react-select-container"
              classNamePrefix="react-select"
            />
            : this.getInput(currentMetadataValue, displayValue)
            }
          </td>
          <td className={this.props.metadataType.syncDirection.name}>{ i18next.t(`sync-directions.${this.props.metadataType.syncDirection.id}`) }</td>
          <td>{currentSyncValue}</td>
        </tr>
    );
  }
}

class DeviceLocationEditButton extends React.Component {
  render() {
    const editMetadataLinkWithParams = {
      link: {
        pathname: `/config/devices/${this.props.device.id}/amtedit/${this.props.groupAssociableMetadataType.id}`,
        state: {
          backLinkSearch: this.props.backLinkSearch,
          searchValue: this.props.searchValue,
          backLinkWithParams: this.props.backLinkWithParams
        }
      }
    };
    return (
      <Link className="btn btn-default btn-xs" to={editMetadataLinkWithParams.link}>{ i18next.t('pages.device-configuration.set-device-location') }</Link>
    );
  }
}

export default DeviceEdit;
